import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export function Layout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 ml-16 lg:ml-64 p-4 md:p-6 overflow-x-auto">
          <div className="max-w-7xl mx-auto min-w-fit">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
